import React from 'react';

import {Property} from '../../utilTypes';
import {DOT, propertyMapToList} from '../utils';
import PropertyHeader from './PropertyHeader';

type NestedOverridesProps = {
  property: Property;
  getElementForProperty: (property: Property) => React.ReactElement;
};

export const NestedOverrides = ({
  property,
  getElementForProperty,
}: NestedOverridesProps) => {
  const subProperties: Property[] = propertyMapToList(
    property.properties,
    property.key,
    property.file
  );
  let bgColor = 'bg-white';
  if ((property.key.match(DOT) || []).length % 2 === 0) {
    bgColor = 'bg-moon-50';
  }
  return (
    <>
      <PropertyHeader property={property} />
      <div
        className={`my-10 w-full rounded border border-moon-250 ${bgColor} p-12`}>
        {subProperties.map((subProperty, idx, arr) => {
          return (
            <React.Fragment key={subProperty.key}>
              {getElementForProperty(subProperty)}
              {idx < arr.length - 1 && (
                <div className="m-[20px_-12px] h-px w-auto bg-moon-250" />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
};
